import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { AnimatedSection, AnimatedItem } from './AnimatedSection';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onToggle
}: FAQItemProps) {
  return <div className="border border-slate-700/30 rounded-xl overflow-hidden bg-navy-700/40" data-id="element-13">
      <button onClick={onToggle} className="w-full flex items-center justify-between p-5 md:p-6 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-400 focus-visible:ring-offset-2 focus-visible:ring-offset-navy-800 rounded-xl" aria-expanded={isOpen} data-id="element-14">
        <span className="font-display text-base md:text-lg font-semibold text-white pr-4" data-id="element-15">
          {question}
        </span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.25
      }} className="flex-shrink-0" data-id="element-16">
          <ChevronDownIcon className="w-5 h-5 text-gold-400" aria-hidden="true" data-id="element-17" />
        </motion.div>
      </button>
      <AnimatePresence initial={false} data-id="element-18">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: [0.25, 0.46, 0.45, 0.94]
      }} data-id="element-19">
            <div className="px-5 md:px-6 pb-5 md:pb-6" data-id="element-20">
              <p className="text-slate-300 font-body text-sm md:text-base leading-relaxed" data-id="element-21">
                {answer}
              </p>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const handleToggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="w-full bg-navy-800" data-id="element-22">
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-20 md:py-28" data-id="element-23">
        <AnimatedSection data-id="element-24">
          <AnimatedItem data-id="element-25">
            <div className="flex items-center gap-3 mb-4" data-id="element-26">
              <div className="h-px flex-1 max-w-[60px] bg-gold-500/40" data-id="element-27" />
              <span className="text-gold-400 text-xs font-body font-semibold tracking-[0.2em] uppercase" data-id="element-28">
                Preguntas Frecuentes
              </span>
            </div>
          </AnimatedItem>

          <AnimatedItem data-id="element-29">
            <h2 className="font-display text-2xl sm:text-3xl md:text-4xl font-bold text-white leading-tight mb-10" data-id="element-30">
              Resolvemos tus <span className="text-gold-400" data-id="element-31">dudas</span>
            </h2>
          </AnimatedItem>

          <div className="space-y-3" data-id="element-32">
            <AnimatedItem data-id="element-33">
              <FAQItem question="¿Necesito ser un experto en finanzas?" answer="No, el plan está escrito en lenguaje sencillo para personas que nunca han invertido. Te guiamos paso a paso desde cero." isOpen={openIndex === 0} onToggle={() => handleToggle(0)} data-id="element-34" />
            </AnimatedItem>

            <AnimatedItem data-id="element-35">
              <FAQItem question="¿Cuánto capital necesito para empezar?" answer="Puedes iniciar con $2,000 a $5,000 para ver resultados significativos de inmediato. No necesitas grandes sumas para comenzar a generar flujo de caja." isOpen={openIndex === 1} onToggle={() => handleToggle(1)} data-id="element-36" />
            </AnimatedItem>

            <AnimatedItem data-id="element-37">
              <FAQItem question="¿Es seguro?" answer="Utilizamos activos de alta calidad y una gestión de riesgo diseñada para proteger tu patrimonio principal. Nunca trabajamos con activos especulativos o de alto riesgo." isOpen={openIndex === 2} onToggle={() => handleToggle(2)} data-id="element-38" />
            </AnimatedItem>

            <AnimatedItem data-id="element-39">
              <FAQItem question="¿Puedo retirar mi dinero?" answer="Sí, tienes control total sobre tu cuenta de inversión en todo momento. Tu dinero nunca queda bloqueado ni comprometido con terceros." isOpen={openIndex === 3} onToggle={() => handleToggle(3)} data-id="element-40" />
            </AnimatedItem>
          </div>
        </AnimatedSection>
      </div>

      <div className="h-px bg-gradient-to-r from-transparent via-gold-500/20 to-transparent" data-id="element-41" />
    </section>;
}